import React, { useEffect, memo } from 'react';

var PLATFORM_URL = 'https://static.elfsight.com/platform/platform.js';
function useLoadPlatform() {
  useEffect(function () {
    if (!isPlatformLoaded()) {
      loadPlatform();
    }
  }, []);
}

function isPlatformLoaded() {
  return isPlatformInitialized() || hasPlatformScript();
}

function isPlatformInitialized() {
  return 'eapps' in window;
}

function hasPlatformScript() {
  return !!document.querySelector("script[src=\"" + PLATFORM_URL + "\"]");
}

function loadPlatform() {
  var scriptElement = document.createElement('script');
  scriptElement.src = PLATFORM_URL;
  scriptElement.defer = true;
  document.head.appendChild(scriptElement);
}

function _ElfsightWidget(_ref) {
  var widgetID = _ref.widgetID;
  useLoadPlatform();
  return React.createElement("div", {
    className: "elfsight-app-" + widgetID
  });
}

var ElfsightWidget = /*#__PURE__*/memo(_ElfsightWidget);

export { ElfsightWidget };
//# sourceMappingURL=react-elfsight-widget.esm.js.map
